<!-- #63 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Day Wise Projection Report
      </div>

      <v-spacer> </v-spacer>
      <v-col cols="12" sm="3" md="3" class="pb-0 pt-0">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="getFormattedDate(projection_date)"
              label="Projection Date"
              append-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
              outlined
              dense
              hide-details="auto"
              class="required"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="projection_date"
            @input="dateMenu = false"
            @change="callApi()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="3" md="3" class="pb-0 pt-0">
        <v-autocomplete
          label="Select warehouse"
          :items="warehousees"
          v-model="wms_warehouse_code"
          :rules="[(v) => !!v || 'Warehouse is required.']"
          class="required pb-0"
          hide-details="auto"
          outlined
          dense
          @change="callApi(wms_warehouse_code)"
        ></v-autocomplete>
      </v-col>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-row v-if="wms_warehouse_code == null || projection_date == null">
      <v-col cols="12" style="text-align: center">
        Please select Warehouse & Projection Date
      </v-col>
    </v-row>
    <v-row
      v-if="
        inboundArr.length == 0 &&
        outboundArr.length == 0 &&
        wms_warehouse_code != null &&
        projection_date != null
      "
    >
      <v-col cols="12" style="text-align: center"> No Data Found </v-col>
    </v-row>
    <v-row
      style="background-color: #e5f2ff; color: black"
      dense
      v-if="inboundArr.length"
    >
      <v-col cols="12">
        <div class="text-center">
          <span>{{ wms_warehouse_code }} Inbound Projections</span>
        </div>
      </v-col>
    </v-row>
    <v-data-table
      v-if="inboundArr.length"
      :headers="headers"
      :items="inboundArr"
      :loading="loader"
      class="elevation-1 custom-icon-size mt-1"
      disable-pagination
      hide-default-footer
      dense
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ inboundArr.indexOf(item) + 1 }}</td>
            <td>{{ item.storer_name }}</td>
            <td>{{ item.vehicle_type }}</td>

            <td>{{ item.vehicle_count }}</td>
            <td>{{ item.pallet_number }}</td>
            <td>{{ item.actual_pallet_number }}</td>
            <td>
              {{ item.proj_qty }}
            </td>

            <td>
              {{ item.actual_qty }}
            </td>
            <td>
              {{ item.actual_qty_percentage }}
            </td>
            <td>
              {{ item.actual_pallet_number_percentage }}
            </td>
          </tr>
          <tr class="custom-footer">
            <td colspan="2">Total</td>
            <td colspan="1"></td>

            <td colspan="1">
              {{ inbound.total_number_of_vehicle }}
            </td>
            <td colspan="1">
              {{ inbound.total_pallet }}
            </td>
            <td colspan="1">
              {{ inbound.total_actual_pallet }}
            </td>

            <td colspan="1">
              {{ inbound.total_projection_quantity }}
            </td>
            <td colspan="3">{{ inbound.total_actual_quantity }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-row
      style="background-color: #e5f2ff; color: black"
      dense
      v-if="outboundArr.length"
    >
      <v-col cols="12">
        <div class="text-center">
          <span>{{ wms_warehouse_code }} Outbound Projections</span>
        </div>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="outboundArr"
      :loading="loader"
      class="elevation-1 custom-icon-size mt-1"
      disable-pagination
      hide-default-footer
      dense
      v-if="outboundArr.length"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ outboundArr.indexOf(item) + 1 }}</td>
            <td>{{ item.storer_name }}</td>
            <td>{{ item.vehicle_type }}</td>
            <td>{{ item.vehicle_count }}</td>

            <td>{{ item.pallet_number }}</td>
            <td>{{ item.actual_pallet_number }}</td>
            <td>
              {{ item.proj_qty }}
            </td>

            <td>
              {{ item.actual_qty }}
            </td>
            <td>
              {{ item.actual_qty_percentage }}
            </td>
            <td>
              {{ item.actual_pallet_number_percentage }}
            </td>
          </tr>
          <tr class="custom-footer">
            <td colspan="2">Total</td>
            <td colspan="1"></td>
            <td colspan="1">
              {{ outbound.total_number_of_vehicle }}
            </td>
            <td colspan="1">
              {{ outbound.total_pallet }}
            </td>
            <td colspan="1">
              {{ outbound.total_actual_pallet }}
            </td>
            <td colspan="1">
              {{ outbound.total_projection_quantity }}
            </td>
            <td colspan="3">
              {{ outbound.total_actual_quantity }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data: () => ({
    inboundArr: [],
    inbound: {},
    outbound: {},
    projection_date: null,
    dateMenu: false,
    headers: [
      {
        text: "S.No.",
        value: "number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Storer",
        value: "storer_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Type of Vehicle",
        value: "vehicle_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "No of Vehicle",
        value: "vehicle_count",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Number Of Pallet",
        value: "pallet_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actual Pallet",
        value: "actual_pallet_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Proj Qty",
        value: "proj_qty",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Actual Qty",
        value: "actual_qty",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Qty %",
        value: "actual_qty_percentage",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pallet %",
        value: "actual_pallet_number_percentage",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    warehousees: [],
    wms_warehouse_code: "",
    outboundArr: [],
  }),

  created() {
    this.fetchStore();
  },
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate());
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  methods: {
    ...mapActions([
      "fetchStorelist",
      "downloadProjectionTemplate",
      "uploadProjection",
      "snackBar",
      "pasProjectionReport",
    ]),
    fetchStore() {
      this.fetchStorelist().then((res) => {
        this.storers = res.data.storer;
        this.warehousees = res.data.warehouses.map(
          (obj) => Object.keys(obj)[0]
        );
      });
    },
    callApi() {
      if (this.wms_warehouse_code && this.projection_date) {
        let payload = {
          warehouse_name: this.wms_warehouse_code,
          projection_date: this.projection_date,
        };
        this.pasProjectionReport(payload).then((res) => {
          this.inboundArr = res.data.inbound.data;
          this.inbound = res.data.inbound;
          this.outbound = res.data.outbound;
          this.outboundArr = res.data.outbound.data;
        });
      }
    },
  },
};
</script>
<style scoped>
.custom-footer {
  font-size: 17px;
  font-weight: bold;
  background-color: #ffd7be;
  width: 100%;
  border-collapse: collapse;
  margin-top: 70px; /* Adjust as needed */
  border: 1px solid gray; /* Add border styles as needed */
}
.custom-footer td {
  background-color: #ffd7be;
  /* width: 500px; */
  border-top: 1px solid lightgray;
  text-align: left; /* Center the content */
}
.text-error {
  color: red;
}
.text-orange {
  color: orange;
}
</style>
